import React, {useEffect, useContext} from 'react'
import {Arguments} from "../common/Arguments";
import {sideMenuContext} from "../../../router/IndexRouter";
import {GetApiMethod} from "../common/ApiMethod";
import TableComponent from "../common/TablePaginationComponent";
import EditComponent from "../common/EditComponent";
import DeleteComponent from "../common/DeleteComponent";
import {Button} from "antd";
import {SortByZhiWu} from "../common/SortListByPost";


export default function PartyMembersAdmin(props) {
    const currentUrl = window.location.href;
    const {dataSource, setDataSource, setCopyDataSource} = useContext(sideMenuContext);
    const getApi = Arguments.host + "/society_organization/party/consortium/api!partyMembers.do";

    useEffect(() => {
        setDataSource([]);
        GetApiMethod({getApi, setDataSource, setCopyDataSource});
    }, [getApi])

    const columns = [
        {
            title: '序号',
            dataIndex: 'showIndex',
            width: 100,
            sorter: (a, b) => a.showIndex - b.showIndex,
            sortDirections: ["ascend", "descend"]
        },
        {
            title: '姓名',
            dataIndex: 'name',
            sorter: (a, b) => a.name.localeCompare(b.name),
            sortDirections: ["ascend", "descend"]
        },
        {
            title: "政治面貌",
            dataIndex: 'zzmm'
        },
        {
            title: "党内职务",
            responsive: ['lg'],
            dataIndex: 'partyZhiWu'
        },
        {
            title: "工作单位",
            responsive: ['lg'],
            dataIndex: 'workUnit'
        },
        {
            title: "操作",
            width: 140,
            render: (item) => (
                <>
                    <EditComponent item={item} url={currentUrl}/>
                    <DeleteComponent
                        item={item}
                        postApi={[Arguments.host + "/society_organization/party/consortium/api!addPartyMember.do"]}
                        getApi={getApi}
                    />
                </>
            )
        }
    ];

    const indexDataSource = SortByZhiWu(dataSource).map((data, index) => ({showIndex: index + 1, ...data}))
    return (
        <>
            <Button type="primary" onClick={() => props.history.push("/party/party-members-admin/add")}
                    style={{marginBottom: 10}}>新增</Button>
            <TableComponent dataSource={indexDataSource} columns={columns}/>
        </>
    )
}
